import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { NzPlacementType } from 'ng-zorro-antd/dropdown';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { AtwUpdateDbComponent, ChooseIconComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'atw-image-detail-admin-config',
  templateUrl: './image-detail-admin-config.component.html',
  styleUrls: ['./image-detail-admin-config.component.scss']
})
export class AtwImageDetailAdminConfig extends AtwUpdateDbComponent implements OnInit {
@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  // Áp dụng Carousel
  isCarouselActive: boolean = false;                // Áp dụng hiệu ứng slide cho hình ảnh chính
  isCarouselOtherImageActive: boolean = false;      // Áp dụng hiệu ứng slide cho hình ảnh khác
  // Áp dụng Image Zoom
  isHoverZoomActive: boolean = false;

  carouselID: string = "";                        // id của carousel đc áp dụng
  gridClass: string = "";                         // class style các kiểu xắp sếp bố cục hình ảnh
  gridObjSelected: any = "object";                // Lưu thành phần được chọn khi chọn trên Khối demo
  arrayImage: any = ['1', '2', '3'];              // Mảng minh họa các hình ảnh của sản phẩm theo thứ tự
  id_subproject: any = "";
  counterIndex: number = 0;
  positionSelect: NzPlacementType = 'bottomCenter';
  carouselState: any = {                          // Lưu dữ liệu của carousel khi vuốt
    pressed: false,
    startX: 0,
    switchCarouselIndex: 0,
    isSpaceSwitch: false
  }
  iconArrowsSelected: any = {                      // Lưu data icon mũi tên được chọn
    icon_left: 'bi bi-chevron-left',
    icon_right: 'bi bi-chevron-right'
  }
  bootstrapIconArrows: any = [                     // List icon cho mũi tên carousel được chọn trong cài đặt
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right'
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short'
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill'
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right'
    },
  ]

  bootstrapIconArrowsUpDown: any = [                     // List icon cho mũi tên carousel được chọn trong cài đặt
    {
      icon_up: 'bi bi-chevron-up',
      icon_down: 'bi bi-chevron-down'
    },
    {
      icon_up: 'bi bi-arrow-up-short',
      icon_down: 'bi bi-arrow-down-short'
    },
    {
      icon_up: 'bi bi-caret-up-fill',
      icon_down: 'bi bi-caret-down-fill'
    },
    {
      icon_up: 'bi bi-chevron-compact-up',
      icon_down: 'bi bi-chevron-compact-down'
    },
  ]
  style_fields = [
    {
      title: 'dieu_chinh_vien_nhom_anh_nho',
      index: 1,
    },
    {
      title: "do_bao_phu",
      index: 2,
      isDrop: false
    },
    {
      title: 'dieu_chinh_vien_icon_anh_lon',
      index: 3,
      isDrop: false
    },
    {
      title: 'dieu_chinh_vien_icon_anh_nho',
      index: 4,
      isDrop: false
    },
    {
      title: 'dieu_chinh_vien_anh_chinh',
      index: 5
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 6,
    }
  ]
  opacityArrow: string = 'icon'
  opacityArrowHover: string = 'icon'
  isViewAll: boolean = false;
  currentViewAll: any = {};
  configMode: 'basic' | 'advanced' = 'basic';
  effect_hover = [];
  effect_hover_data: any = {};

  constructor(
    private http: HttpClient,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    private dialog: MatDialog,
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngAfterViewChecked(): void {
    this.setVariablesValue();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
    
    if (!this.class.hasOwnProperty('orther-image__list')) {
      this.class['orther-image__list'] = {};
    }

    if (!this.config.orther_image.hasOwnProperty('is_hide_arrow')) {
      this.config.orther_image.is_hide_arrow = false;
    }
    if (!this.config.main_image.hasOwnProperty('is_hide_arrow')) {
      this.config.main_image.is_hide_arrow = false;
    }
    if (!this.config.orther_image.hasOwnProperty('is_arrow_action')) {
      this.config.orther_image.is_arrow_action = false;
    }
    if (!this.class.hasOwnProperty('sm-image__icon-video--wrapper')) {
      this.class['sm-image__icon-video--wrapper'] = {
        width: '36px',
        height: '26px',
        'background-color': '#f00',
        'background-image': 'none',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        'border-color': 'transparent',
        'border-style': 'solid',
        'border-top-width': '0px',
        'border-bottom-width': '0px',
        'border-left-width': '0px',
        'border-right-width': '0px',
        'border-top-left-radius': '8px',
        'border-top-right-radius': '8px',
        'border-bottom-left-radius': '8px',
        'border-bottom-right-radius': '8px',
        'box-shadow': 'none',
      };
    }
    if (!this.class.hasOwnProperty('sm-image__icon-video')) {
      this.class['sm-image__icon-video'] = {
        'font-size': '20px',
        color: '#fff',
      };
    }
    if (!this.config.hasOwnProperty('video_youtube')) {
      this.config['video_youtube'] = { icon: 'play_arrow' };
    }

    this.config['image-detail__images'] ??= {};
    this.config['image-detail__images']['cols'] ??= 2;
    this.config['image-detail__images']['is_list_view'] ??= false;
    this.class['image-detail__images'] ??= {
      "display":"flex", 
      "position": "relative", 
      "width": "100%", 
      "height": "100%", 
      "flex-wrap": "wrap",
      "gap": "10px",
    };
    this.class['image-detail__images--item'] ??= {};
    // this.gridObjSelected = 'object';
    this.createElementID();
  }


  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/image-detail.json'), 
    ]) .subscribe(([effects]:any)=>{
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });
    this.setVariablesValue();
  }


  /* Set value css cho đối tượng */
  setVariablesValue() {
    if (isPlatformBrowser(this.platformId))
      if (this.device === 'desktop') {
        document.documentElement.style.setProperty('--image-detail-variable-arrow-background-color', this.config['main_image']['arrow_action_hover_background']);
        document.documentElement.style.setProperty('--image-detail-variable-arrow-color', this.config['main_image']['arrow_action_hover_color']);
        document.documentElement.style.setProperty('--image-detail-variable-arrow-duration', this.config['main_image']['arrow_action_hover_duration'] + 's');
        document.documentElement.style.setProperty('--image-detail-variable-arrow-opacity', this.config['main_image']['arrow_action_hover_opacity'] + '%');

      }
  }


  /* Set value css cho đối tượng */
  setVariablesValueUpDown() {
    if (isPlatformBrowser(this.platformId))
      if (this.device === 'desktop') {
        document.documentElement.style.setProperty('--image-detail-variable-arrow-background-color', this.config['orther_image']['arrow_action_hover_background']);
        document.documentElement.style.setProperty('--image-detail-variable-arrow-color', this.config['orther_image']['arrow_action_hover_color']);
        document.documentElement.style.setProperty('--image-detail-variable-arrow-duration', this.config['orther_image']['arrow_action_hover_duration'] + 's');
        document.documentElement.style.setProperty('--image-detail-variable-arrow-opacity', this.config['orther_image']['arrow_action_hover_opacity'] + '%');

      }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['image-detail']['width'] = event.width + 'px';
    if (event.height) this.class['image-detail']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  /* Tạo id cho carousel */
  createElementID() {
    this.carouselID = 'image-detail-slider-' + 'review';
  }


  /*---------Carousel Method ( Chọn hiệu ứng Carousel cài đặt ) -----------*/

  /**
   * 
   * @param element element cần lấy translateX
   * @returns translateX: number
   */
  getTranslateX(element) {
    if (isPlatformBrowser(this.platformId)) {
      var style = window.getComputedStyle(element);
      var matrix = new WebKitCSSMatrix(style.transform);
      return matrix.m41;
    }
    return 0
  }

  /**Click next của Carousel cài đặt 
   * 
   * @param id : id của carousel 'effect-carousel'
   * @param amountStep số lần chuyển slide mong muốn (tự xác định trước)
   */
  onNext(id, amountStep) {
    if (isPlatformBrowser(this.platformId)) {
      var inner = document.querySelector(`#${id} .carousel-slide-inner`) as HTMLElement;
      var step = 128;
      var value = step - this.getTranslateX(inner);
      if (-value < -(amountStep * step * 2)) {
        // -value: giá trị từ 0 tăng lên 128 lần khi qua carousel kế tiếp.
        // -(amountStep * step * 2): giá trị -256 là tổng của 3 carousel.
        // khi -value < -256 => set value = 0.
        value = 0;
      }
      inner.style.transform = `translateX(-${value}px)`;
    }
  }

  /*----------------------CLICK CONTROL ARROW----------------------*/
  /** Xử lí chuyển slide của carousel
  * @param id : id của carousel [carouselID]
  */
  hanldeNext(id) {
    if (isPlatformBrowser(this.platformId)) {
      const innerSlider = document.querySelector(`#${id} #carousel-inner`) as HTMLElement;
      const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
      let step = containerLayer.clientWidth;
      this.counterIndex += 1;
      if (this.counterIndex > this.arrayImage.length - 1)
        this.counterIndex = this.arrayImage.length - 1;

      var nextSlideIndex = -step * this.counterIndex;
      innerSlider.style.left = `${nextSlideIndex}px`;
    }
  }


  /** Xử lí chuyển slide của carousel
  * @param id : id của carousel [carouselID]
  */
  hanldePrev(id) {
    if (isPlatformBrowser(this.platformId)) {
      const innerSlider = document.querySelector(`#${id} #carousel-inner`) as HTMLElement;
      const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
      let step = containerLayer.clientWidth;

      this.counterIndex -= 1;
      if (this.counterIndex < 0)
        this.counterIndex = 0;
      var nextSlideIndex = -step * this.counterIndex;
      // 
      innerSlider.style.left = `${nextSlideIndex}px`;
    }
  }


  /** Xử lí | kiểm tra hiệu ứng chuyển slide của carousel
 * @param id : id của carousel [carouselID]
 * @event 
 * các hiệu ứng 
 * 'carousel-default' : mặc định
 * 'carousel-fadeout' : mờ dần
 * 'carousel-transition' : chuyển tiếp
 */
  onImageNext(id, event) {
    switch (this.config['main_image']['effect_carousel_class']) {
      case 'carousel-default':
        this.counterIndex += 1;
        if (this.counterIndex == this.arrayImage.length)
          this.counterIndex = 0;
        break;

      case 'carousel-fadeout':
        this.counterIndex += 1;
        if (this.counterIndex == this.arrayImage.length)
          this.counterIndex = 0;
        break;

      case 'carousel-transition':
        event.stopPropagation();
        this.hanldeNext(id);
        break;
      default:
      // code block
    }
  }

  /** Xử lí | kiểm tra hiệu ứng chuyển slide của carousel
  * @param id : id của carousel [carouselID]
  * @event 
  */
  onImagePrev(id) {
    switch (this.config['main_image']['effect_carousel_class']) {
      case 'carousel-default':
        this.counterIndex -= 1;
        if (this.counterIndex < 0)
          this.counterIndex = this.arrayImage.length - 1;
        break;

      case 'carousel-fadeout':
        this.counterIndex -= 1;
        if (this.counterIndex < 0)
          this.counterIndex = this.arrayImage.length - 1;
        break;

      case 'carousel-transition':
        this.hanldePrev(id);
        break;
      default:
      // code block
    }
  }


  /** Đi tới slide thứ number
  * @param id : id của carousel [carouselID]
  * @param number :  vị trí slide trong mảng hình ảnh arrayImage
  */
  gotoImageIndex(id, number) {
    switch (this.config['main_image']['effect_carousel_class']) {
      case 'carousel-default':
        this.counterIndex = number;
        break;

      case 'carousel-fadeout':
        this.counterIndex = number;
        break;

      case 'carousel-transition':
        if (isPlatformBrowser(this.platformId)) {
          const innerSlider = document.querySelector(`#${id} #carousel-inner`) as HTMLElement;
          const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
          let step = containerLayer.clientWidth;
          this.counterIndex = number;
          if (this.counterIndex > this.arrayImage.length - 1)
            this.counterIndex = this.arrayImage.length - 1;
          var nextSlideIndex = -step * this.counterIndex;
          innerSlider.style.left = `${nextSlideIndex}px`;
        }
        break;
      default:
      // code block
    }
  }


  /*----------------------SWITCH SLIDER----------------------*/
  /** Function event khi ấn chuột vào ảnh và giữ lại
  * @param id : id của carousel [carouselID]
  * @param event
  */
  onMouseDown(id, event) {
    event.stopPropagation();
    if (isPlatformBrowser(this.platformId))
      if (this.config['main_image']['effect_carousel_class'] == 'carousel-transition') {
        const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
        const innerSlider = document.querySelector(`#${id} #carousel-inner`) as HTMLElement;
        this.carouselState.pressed = true;
        this.carouselState.startX = event.offsetX - innerSlider.offsetLeft;
        containerLayer.style.cursor = "grabbing";
      }
  }


  /** Function event khi nhả chuột khỏi ảnh
  * @param id : id của carousel [carouselID]
  * @param event 
  */
  onMouseUp(id, event) {
    event.stopPropagation();
    if (isPlatformBrowser(this.platformId))
      if (this.config['main_image']['effect_carousel_class'] == 'carousel-transition') {
        const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
        this.carouselState.pressed = false;
        containerLayer.style.cursor = "grab";
        this.checkBoundary(id);
      }
  }


  /** Function event khi chuột nằm trong ảnh
  * @param id : id của carousel [carouselID]
  * @param event 
  */
  onMouseEnter(id, event) {
    // event.stopPropagation();
    if (isPlatformBrowser(this.platformId))
      if (this.config['main_image']['effect_carousel_class'] == 'carousel-transition') {
        const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
        containerLayer.style.cursor = "grab";
      }
  }

  /** Function event khi di chuyển chuột trong ảnh
 * @param id : id của carousel [carouselID]
 * @param event 
 */
  onMouseMove(id, event) {
    event.stopPropagation();
    if (isPlatformBrowser(this.platformId))
      if (this.config['main_image']['effect_carousel_class'] == 'carousel-transition') {
        const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
        const innerSlider = document.querySelector(`#${id} #carousel-inner`) as HTMLElement;
        if (this.carouselState.pressed === false) return;
        event.preventDefault();
        var x = event.offsetX;
        innerSlider.style.left = `${x - this.carouselState.startX}px`;
        containerLayer.style.cursor = "grab";
        this.carouselState.switchCarouselIndex = x - this.carouselState.startX;
      }
  }

  /** Kiểm tra xem ảnh đã ở giới hạn chưa
 * @param id : id của carousel [carouselID]
 * @param event 
 */
  checkBoundary(id) {
    if (isPlatformBrowser(this.platformId)) {
      const containerLayer = document.querySelector(`#${id} .carousel-layer`) as HTMLElement;
      let step = containerLayer.clientWidth;
      if (this.carouselState.switchCarouselIndex < -step * (this.counterIndex)) {
        this.hanldeNext(id)
      }
      else {
        this.hanldePrev(id);
      }
      if (this.counterIndex > this.arrayImage.length - 1)
        this.counterIndex = this.arrayImage.length - 1;
    }
  };

  /*--------- EFFECT SELECT METHOD -------------------*/

  /** Chọn hiệu ứng khi chuyển slide
  * @param effectName : Tên hiệu ứng 'carousel-default' | 'carousel-fadeout' | 'carousel-transition' | 'carousel-default'
  */
  onSelectEffect(effectName) {
    if (isPlatformBrowser(this.platformId)) {
      this.counterIndex = 0;
      const blockInner = document.querySelector(`#${this.carouselID} #carousel-inner`) as HTMLElement;
      blockInner.style.left = `0px`;
      switch (effectName) {
        case 'default':
          this.config['main_image']['effect_carousel_class'] = 'carousel-default'
          break;
        case 'fade':
          this.config['main_image']['effect_carousel_class'] = 'carousel-fadeout'
          break;
        case 'transition':
          this.config['main_image']['effect_carousel_class'] = 'carousel-transition'
          break;
        default:
          this.config['main_image']['effect_carousel_class'] = 'carousel-default'
      }
      this.updateConfig()
    }
  }

  /*--------- Mở cài đặt hình ảnh -------------------*/

  onClickObject(target, event) {
    event.stopPropagation();
    var objSelected = event.currentTarget;
    this.removeOutlineActive();
    objSelected.classList.add('active-select')
    this.gridObjSelected = target;
  }

  removeOutlineActive() {
    if (isPlatformBrowser(this.platformId)) {
      var lastSelected = document.querySelectorAll('.active-select');
      if (lastSelected)
        lastSelected.forEach((element: any) => {
          element.classList.remove("active-select")
        })
    }
  }

  updateRowCol() {
    this.updateConfig();
    this.updateClass();
    this.vhEventMediator.notifyOnConfigChanged({ _id: this.objectChoosing._id, change_total_images: true })
  }

  handleListView(event) {
    this.config['image-detail__images']['is_list_view'] = event;
    if (event) {
      this.config['image-detail__images'] ??= {};
      this.config['image-detail__images']['cols'] ??= 2;
      this.config['image-detail__images']['is_list_view'] ??= false;
      this.class['image-detail__images'] ??= {
        "display":"flex", 
        "position": "relative", 
        "width": "100%", 
        "height": "100%", 
        "flex-wrap": "wrap",
        "gap": "10px",
      };
      this.class['image-detail__images--item'] ??= {};
    }
    this.updateConfig();
  }
  
//   /*--------- Khu vực Image design-------------------*/
//   // Lưu DB
//   /**
// * Hàm update object vào database.
// */
//   updateObject() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
//       .then((bool: any) => {

//       })
//   }
//   /**
//   *Hàm update config vào database.
//   */
//   updateConfig() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
//       .then((bool: any) => {

//       })
//   }


//   /**
//   *Hàm update class vào database.
//   */
//   updateClass() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
//       .then((bool: any) => {

//       })
//   }

  /*--------- Thay đổi mũi tên chuyển slide carousel -------------------*/
  onChangeArrows(arrows) {
    this.config['main_image']['arrow_left_icon'] = arrows.icon_left;
    this.config['main_image']['arrow_right_icon'] = arrows.icon_right;
    this.updateObject()
  }

  onChangeArrowsGrid2(arrows) {
    this.config['orther_image']['arrow_left_icon'] = arrows.icon_left;
    this.config['orther_image']['arrow_right_icon'] = arrows.icon_right;
    this.updateObject()
  }

  onChangeArrowsUpDown(arrows) {
    this.config['orther_image']['arrow_up_icon'] = arrows.icon_up;
    this.config['orther_image']['arrow_down_icon'] = arrows.icon_down;
    this.updateObject()
  }
  /*--------- Thay đổi màu sắc mũi tên chuyển slide carousel -------------------*/
  onSelectColor() {
    if (isPlatformBrowser(this.platformId)) {
      const color = document.querySelector("#colour") as HTMLElement;
      color.click();
    }
  }

  /*--------- Return color with RGB color and opacity -------------------*/
  /*
    apply: Field thuộc tính css nhận màu 
    - > vd: arrow_background_color , arrow_color ...
  */
  onChangeColour(apply, event) {
    this.config['main_image'][apply] = this.hexToRgbA(event.target.value, 1);
    this.config['main_image'][apply + '_opacity'] = 100;
    this.updateConfig()
    this.setVariablesValue();
  }

  onChangeColourOpacity(apply, event) {
    var rgba = this.config['main_image'][apply];
    var alpha = ',' + rgba.replace(/^.*,(.+)\)/, '$1') + ')';
    var newAlpha = ',' + event / 100 + ')'
    var newRGBA = this.config['main_image'][apply].replace(alpha, newAlpha)
    this.config['main_image'][apply] = newRGBA;
    this.updateConfig()
    this.setVariablesValue();
  }

  onChangeColourOpacityUpDown(apply, event) {
    var rgba = this.config['orther_image'][apply];
    var alpha = ',' + rgba.replace(/^.*,(.+)\)/, '$1') + ')';
    var newAlpha = ',' + event / 100 + ')'
    var newRGBA = this.config['orther_image'][apply].replace(alpha, newAlpha)
    this.config['orther_image'][apply] = newRGBA;
    this.updateConfig()
    this.setVariablesValueUpDown();
  }



  /** Xử lí lưu vị trí ảnh
    * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
    */
  handleSetPositionImage() {
    if (this.config.object_fit_ortherimage.object_x == 0 && this.config.object_fit_ortherimage.object_y == 0)
      this.class['orther-image']['object-position'] = 'initial';
    else {
      this.class['orther-image']['object-position'] = `${this.config.object_fit_ortherimage.object_x}px ${this.config.object_fit_ortherimage.object_y}px`;
    }
    this.updateObject();
  }

  //Hàm xử lý scale
  scale() {
    this.class['orther-image']['transform'] = `scale(${this.class['orther-image']['transfrom_scale']})`;
  }
  /*--------- Chuyển mã màu từ hex qua rgba-----------*/
  hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + `,${opacity})`;
    }
    throw new Error('Bad Hex');
  }

  /*---------Mở bảng chọn màu-----------*/
  openColour(event) {
    const targetColor = event.currentTarget;
    const colorControl = targetColor.querySelector(".colour");
    colorControl.click();
  }

  /*---------Chọn thuộc tính màu css muốn thay đổi-----------*/
  /*
    - > vd: arrow_background_color , arrow_color ...
  */
  onSelectColorFor(event) {
    // 
  }

  /*--------- PHÓNG ĐẠI HÌNH ẢNH -------------------*/
  onZoomSwitch() {
    this.config['main_image']['effect_carousel_class'] = 'carousel-default';
    // this.config['main_image']['is_active_carousel'] = false;

    
    // Trường hợp mở phóng to thì phải phải tắt hiệu ứng
    if (this.config['main_image']['is_active_image_zoom'] && this.config['animation-selected']['id'] !== '000000') {
      this.config['animation-selected']['id'] = '000000';
      this.staticdata[this.device + '_animation'] = {};
      this.staticdata[this.device + '_animation']['animation-0'] = {};
      this.staticdata[this.device + '_animation_type'] = 'none';
      this.updateStaticData();
    }
    this.updateConfig()
  }

  /* ---------------------------- XỬ LÝ MENU CONFIG --------------------------- */

  isOpenViewAll(event) {
    this.currentViewAll = event;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
      Object.keys(targetMap).forEach(key => {
        if (key !== value) targetMap[key] = false;
    });
  }

  openMapSub: { [name: string]: boolean } = {submenu1: true, submenu2: false};
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false,
    menu14: false,
  };

  customize = [];
  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.style_fields[5])
  }

  openDialogChooseIcon() {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.config.video_youtube ??= {};
        this.config.video_youtube.icon = result.icon;
        this.updateConfig();
      }
    });
  }
}
